module.exports = __webpack_public_path__ + "static/media/tear_through.6d6b2ce3.svg";